import React from 'react'
import ContentProgressList from '../components/ContentProgressList'
import { useCompletions, useTracks } from '../api/selectors'

const ContentProgressPanel = () => <ContentProgressList tracks={useTracks()} completions={useCompletions()} />

export default ContentProgressPanel
